function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const constants = require('./constants');
const sanitize = require('./sanitize');
const mock = require('./mock');
const ROOT_LOGGER = 'root';
const buildReference = ref => `${constants.LOGGER_REFERENCE_PREFIX} ${ref} ${constants.LOGGER_REFERENCE_SUFFIX}`;

// This requires a subclass to extend and add a _logAtLevel class to handle the log levels
let Logger = /*#__PURE__*/function () {
  "use strict";

  function Logger(modReference = '') {
    _classCallCheck(this, Logger);
    // We wrap the prefix in the brackets to create a standard searchable term
    // in the logs
    this._prefix = !modReference ? '' : buildReference(modReference);
    this._loggerInstance = !modReference ? ROOT_LOGGER : modReference;
  }
  _createClass(Logger, [{
    key: "debug",
    value: function debug(...args) {
      this._logAtLevel('debug', ...this._constructMessage(...args));
    }
  }, {
    key: "info",
    value: function info(...args) {
      this._logAtLevel('info', ...this._constructMessage(...args));
    }
  }, {
    key: "warn",
    value: function warn(...args) {
      this._logAtLevel('warn', ...this._constructMessage(...args));
    }
  }, {
    key: "error",
    value: function error(...args) {
      this._logAtLevel('error', ...this._constructMessage(...args));
    }
  }, {
    key: "alert",
    value: function alert(...args) {
      this._logAtLevel('alert', ...this._constructMessage(...args));
    }

    // The common case, and the one that we have to support because of backwards compatability, is just using the root
    // logger directly. If we do that, we don't want to prepend any module reference information to the message.
  }, {
    key: "_constructMessage",
    value: function _constructMessage(...args) {
      return this._loggerInstance === ROOT_LOGGER ? args : [this._prefix, ...args];
    }
  }, {
    key: "fromCurrentFunction",
    value: function fromCurrentFunction() {
      return this;
    }
  }]);
  return Logger;
}();
/**
 * All of these fields are to maintain backwards compatibility
 */
Logger.prototype.mock = mock;
Logger.prototype.addSanitizedKeys = sanitize.addSanitizedKeys;
module.exports = Logger;